import React from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import { IconProp } from 'models/Icon';

import './FloatingButton.styles.scss';
import './FloatingButton.styles.responsive.scss';

type FloatingButtonProps = {
  className?: string;
  disabled?: boolean;
  icon: IconProp;
  onClick: () => void;
};

const FloatingButton: React.FC<FloatingButtonProps> = (props) => {
  const { className, disabled, icon, onClick } = props;

  const classes = classNames('floating-button', className);

  return (
    <Button
      className={classes}
      icon={icon}
      disabled={disabled}
      onClick={onClick}
    />
  );
};

export default FloatingButton;
